import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

const plainTextOkResponse = c.otherResponse({ contentType: 'text/plain', body: z.string() });

export const declarationsReportsContract = c.router({
  generateDailyReport: {
    method: 'POST',
    path: '/declarations/generate-daily-report',
    body: z.object({ date: z.string() }),
    responses: {
      200: plainTextOkResponse,
      400: z.object({ message: z.string() }),
    },
  },
  generateIntrastatReport: {
    method: 'POST',
    path: '/declarations/generate-intrastat-report',
    body: z.object({ month: z.number().optional().nullable(), year: z.number(), quarter: z.number().optional().nullable() }),
    responses: {
      200: plainTextOkResponse,
      400: z.object({ message: z.string() }),
    },
  },
  generateIntervatReport: {
    method: 'POST',
    path: '/declarations/generate-intervat-report',
    body: z.object({ month: z.number().optional().nullable(), year: z.number().optional(), quarter: z.number().optional().nullable() }),
    responses: {
      200: plainTextOkResponse,
      400: z.object({ message: z.string() }),
    },
  },
  generateIntracomReport: {
    method: 'POST',
    path: '/declarations/generate-intracom-report',
    body: z.object({ month: z.number().optional().nullable(), year: z.number().optional(), quarter: z.number().optional().nullable() }),
    responses: {
      200: plainTextOkResponse,
      400: z.object({ message: z.string() }),
    },
  },
  generateBatchesReport: {
    method: 'POST',
    path: '/declarations/generate-batches-report',
    body: z.object({ date: z.string() }),
    responses: {
      200: z.any(),
      400: z.object({ message: z.string() }),
    },
  },
  exportWithRiskAnalysis: {
    method: 'POST',
    path: '/declarations/exportWithRiskAnalysis',
    body: z.object({
      batchId: z.string().optional(),
      startDate: z.string().optional(),
      endDate: z.string().optional(),
      type: z.string().optional(),
      allStatus: z.boolean().optional(),
      declarationId: z.string().optional(),
      status: z.string().optional(),
    }),
    responses: {
      200: plainTextOkResponse,
      400: z.object({ message: z.string() }),
    },
  },
});
